module.exports = __webpack_public_path__ + "img/building_42_headshot.feabd99b.jpg";